import React, { Component } from 'react'
import GuestRouter from './config/routing/GuestRouter'
import ProviderRouter from 'config/routing/ProviderRouter'
// Legacy multi-step profile & verification routers removed from initial registration flow.
// import CompleteProfileRouter from 'config/routing/CompleteProfileRouter'
// import CompleteVerificationRouter from 'config/routing/CompleteVerificationRouter'
import SelectCoverageRouter from 'config/routing/SelectCoverageRouter'
import AdminRouter from 'config/routing/AdminRouter'
import { NotificationContainer } from 'react-notifications'
import { withRouter } from 'react-router-dom'
import { Auth } from 'aws-amplify'
import Loader from './components/general/Loader'
import ProviderAPI from 'config/api/ProviderAPI'
import { onError, logError } from './config/lib/errorLib'
import ErrorBoundary from './components/general/ErrorBoundary'
import CompanyNotFound from './components/general/CompanyNotFound'
import { GoogleMapsProvider } from 'config/GoogleMapsProvider'

const isLocal = process.env.NODE_ENV === 'development'

// Turn off logs in production
if (!isLocal) {
    console.log = function() {}
}

class App extends Component {
    constructor(props) {
        super(props)
        console.log(this.props)
        this.state = {
            loading: true,
            email: null,
            companyName: null,
            details: null,
            companyUrl: null,
            isEeAdmin: false
        }
        this.api = new ProviderAPI()
        this.handleSkipRegistration = this.handleSkipRegistration.bind(this)
        this.handleCoverageSelected = this.handleCoverageSelected.bind(this)
    }

    async componentDidMount() {
        await this.checkCurrentUser()
    }

    async checkCurrentUser() {
        try {
            const info = await Auth.currentUserInfo()
            console.log('info: ', info)
            console.log(this.props.authState)

            if (this.props.authState === 'signedIn' && Object.keys(info).length === 0) {
                this.logout()
            }

            let email = (info && info.attributes['email']) ? info.attributes['email'] : ''
            console.log('email: ', email)
            // EE platform admin is determined server-side by the custom:role claim; the
            // frontend only uses it to decide which UI to render (the API is the real gate).
            let isEeAdmin = !!(info && info.attributes && info.attributes['custom:role'] === 'ee-admin')
            let companyName = isEeAdmin ? 'Admin' : (info && info.attributes['custom:companyName']) ? info.attributes['custom:companyName'] : ''
            console.log('provider name: ', companyName)
            let companyUrl = (info && info.attributes['custom:companyUrl']) ? info.attributes['custom:companyUrl'] : ''
            console.log('company url: ', companyUrl)

            let details = null
            if (this.props.authState === 'signedIn' && !isEeAdmin) {
                details = await this.api.getCompany()
            }
            console.log('provider details: ', details)

            if (this.props.authState === 'signedIn' && !isEeAdmin && (!details || !details.companyId)) {
                logError(new Error('User signed in but has no companyId — blank screen likely'), { email, issue: 'Missing companyId on login' })
            }

            this.setState({
                email: email,
                companyName: companyName,
                details: details,
                companyUrl: companyUrl,
                isEeAdmin: isEeAdmin,
                loading: false
            })
        } catch(e) {
            onError(e)
        }
    }

    async handleSkipRegistration() {
        try {
            if (!this.state.details || !this.state.details.companyId) return
            await this.api.skipRegistration(this.state.details.companyId)
            this.setState(prev => ({
                details: { ...prev.details, skipRegistration: true }
            }), () => {
                // After state update redirect to billing
                if (this.props.history) {
                    this.props.history.push('/billing')
                }
            })
        } catch(e) {
            onError(e)
        }
    }

    async handleCoverageSelected(companyId) {
        try {
            // Refresh company details to reflect newly saved coverage
            const updated = await this.api.getCompany()
            this.setState({ details: updated }, () => {
                if (this.props.history) {
                    this.props.history.push('/billing')
                }
            })
        } catch(e) {
            onError(e)
        }
    }

    logout() {
        Auth.signOut().then(() => {
            window.location.replace('/')
        }).catch(err => 
            onError(err)
        )
    }

    render() {
        const { details, email, companyUrl } = this.state
        // Products this provider offers (admin-controlled via productsAvailable).
        const enabledProducts = details && details.productsAvailable
            ? Object.keys(details.productsAvailable).filter(p => details.productsAvailable[p])
            : []
        // New gating: provider access granted once coverage selected (counties or eircode areas) OR skipRegistration (admin override).
        const coverageSelected = details && ((details.counties && details.counties.length > 0) || (details.eircodeAreas && details.eircodeAreas.length > 0))
        const isSolarProvider = enabledProducts.includes('Solar')
        // Solar providers must select coverage before accessing the provider app.
        const needsSolarCoverage = isSolarProvider && !coverageSelected && !details.skipRegistration
        // All providers (solar with coverage/override, or any non-solar product) can access the provider app.
        const canAccessProvider = details && !needsSolarCoverage
        return (
            <GoogleMapsProvider>
                <ErrorBoundary>
                    <>
                        <NotificationContainer />
                        {!this.state.loading ? (
                            <>
                                {this.props.authState !== 'signedIn' ? (
                                    <GuestRouter />
                                ) : (
                                    <>
                                        {this.state.isEeAdmin &&
                                            <AdminRouter email={this.state.email} />
                                        }
                                        {!this.state.isEeAdmin && !details &&
                                            <CompanyNotFound companyUrl={companyUrl} email={email} />
                                        }
                                        {/* Solar providers without coverage must select it first */}
                                        {details && needsSolarCoverage &&
                                            <SelectCoverageRouter 
                                                email={this.state.email}
                                                companyName={this.state.companyName}
                                                companyDetails={details}
                                                onCoverageSelected={this.handleCoverageSelected}
                                            />
                                        }
                                        {/* All providers with access (any product) get the full provider app */}
                                        {details && canAccessProvider &&
                                            <ProviderRouter 
                                                details={details} 
                                                companyDetails={details} 
                                                skipped={details.skipRegistration}
                                                isSolarProvider={isSolarProvider}
                                                enabledProducts={enabledProducts}
                                            />
                                        }

                                    </>
                                )}
                            </>
                        ) : (
							<Loader 
								className='full-page-loader'
							/>
                        )}
                    </>
                </ErrorBoundary>
            </GoogleMapsProvider>
        )
    }
}

export default withRouter(App)